import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getContext, getSelectedLocation, getEventMessage, getLocation, setSelectedLocation, } from '../workspaces/redux/spaces-slice';
import { BuildingView } from './building';
import FloorView from './floor/layout';
import { NavigatorView } from './navigator';
import { resolveActiveFloorLocation, sendLogsToServer, smartRoomsCall, } from './floor/util';
import { getSmartRooms } from '../../store/uislice';
import { useStatusQuery } from './service/domain-api';
import { DataService } from '../configure/service/deviceservice';
import Loader from '../../common/loader/loader';
import { isRegistered, setToken, clearError } from '../../store/authslice';
import Error from '../../common/error/error';
import NatsClient from '../../store/natsclient';
import { loadPage } from '../../common/util';
import { store } from '../../store/store';
import { isHiddenOnKiosk } from './floor/util/show-on-kiosk';
import { resolveFloorAccess } from './floor/util/floor-access';
import { resolveWhereAmIFloor } from './floor/util/where-am-i';
import { resetWorkspaceView } from './floor/util/reset-view';
export function Workspaces() {
    var _a;
    const dispatch = useDispatch();
    const dataService = new DataService();
    const registered = useSelector((state) => state.auth.registered);
    const contextData = useSelector((state) => state.auth.contextData);
    const currntviewToken = useSelector((state) => state.auth.token);
    const viewType = useSelector((state) => state.auth.viewType);
    const error = useSelector((state) => state.auth.error);
    const [skip, setSkip] = useState(false);
    const statusAPIUrl = `${window.location.origin}/v1/${dataService.getDeviceToken()}/status`;
    const { data: statusData, refetch } = useStatusQuery(statusAPIUrl, { skip });
    const selectedLocation = useSelector(getSelectedLocation);
    const locationData = useSelector(getLocation);
    const contextInfo = useSelector(getContext);
    const eventMessage = useSelector(getEventMessage);
    const tenantId = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.tenantId;
    const isSmartRoomsCallMade = useSelector(getSmartRooms).length != 0;
    const [shouldPendoInitialize, setShouldPendoInitialize] = useState(false);
    const defaultFloorIdFromContext = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.defaultFloorId;
    const [defaultFloorId, setDefaultFloorId] = useState(null);
    if (tenantId && !isSmartRoomsCallMade)
        smartRoomsCall(tenantId);
    // Navigator checks access against its own building/floor/room hierarchy.
    // The shared floor-navigation restrictions below apply to kiosk/web views.
    const isBuildingRestricted = viewType !== 'navigator' && isHiddenOnKiosk(locationData);
    // Resolve fixed-floor access before applying any recovery selection.
    const { floorLocationData: activeFloorLocation } = resolveActiveFloorLocation(locationData, contextInfo, selectedLocation !== null && selectedLocation !== void 0 ? selectedLocation : '');
    const { restricted: isFloorRestricted, redirectFloorId } = resolveFloorAccess(locationData, viewType, selectedLocation || (viewType === 'floor' ? activeFloorLocation === null || activeFloorLocation === void 0 ? void 0 : activeFloorLocation.id : ''), contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.defaultFloorId, (_a = resolveWhereAmIFloor(locationData, contextInfo)) === null || _a === void 0 ? void 0 : _a.id);
    useLayoutEffect(() => {
        if (redirectFloorId === undefined && !isFloorRestricted)
            return;
        resetWorkspaceView(dispatch, { floorId: redirectFloorId });
    }, [dispatch, redirectFloorId, isFloorRestricted]);
    useEffect(() => {
        var _a;
        if ((viewType !== 'building' && viewType !== 'floor') ||
            isFloorRestricted ||
            redirectFloorId !== undefined) {
            return;
        }
        const locationChildren = (_a = locationData === null || locationData === void 0 ? void 0 : locationData.children) !== null && _a !== void 0 ? _a : [];
        if (locationChildren.length === 0) {
            return;
        }
        const selectedLocationExists = selectedLocation
            ? locationChildren.some((child) => child.id === selectedLocation)
            : false;
        if (selectedLocationExists) {
            return;
        }
        if (!selectedLocation && (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.viewType) !== 'floor') {
            return;
        }
        const { floorLocationId } = resolveActiveFloorLocation(locationData, contextInfo, selectedLocation);
        if (floorLocationId && floorLocationId !== selectedLocation) {
            dispatch(setSelectedLocation(floorLocationId));
        }
    }, [
        contextInfo,
        dispatch,
        locationData,
        selectedLocation,
        viewType,
        isFloorRestricted,
        redirectFloorId,
    ]);
    useEffect(() => {
        if (defaultFloorIdFromContext) {
            store.dispatch(setSelectedLocation(defaultFloorIdFromContext));
        }
    }, [defaultFloorIdFromContext]);
    useEffect(() => {
        if (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.shouldPendoInitialize) {
            setShouldPendoInitialize(contextInfo.shouldPendoInitialize);
        }
    }, [contextInfo]);
    useEffect(() => {
        if (shouldPendoInitialize) {
            const { tenantId, customerName, pendoExtra = {} } = contextInfo;
            const { pendoVisitorExtra = {}, pendoAccountExtra = {} } = pendoExtra;
            const baseUrl = location.host;
            const token = dataService.getDeviceToken();
            const pendo = 'pendo';
            // const { iframeMessage = {} } = state;
            // const {
            //   type: iframeMsgType = null,
            //   // data: iframeMsgData = null
            // } = iframeMessage;
            // let hosted = 'WebexBoard';
            // if (iframeMessage && iframeMsgType && iframeMsgType === 'setToken@dnas-sw') {
            //   hosted = 'WebApp';
            // }
            console.log('pendo values', `${token}_${tenantId}_${baseUrl}`);
            if (window[pendo]) {
                const pendoParams = {
                    visitor: Object.assign({ id: `${token}_${tenantId}_${baseUrl}` }, pendoVisitorExtra),
                    account: Object.assign({ id: `${tenantId}_${baseUrl}`, customerName }, pendoAccountExtra),
                };
                window[pendo].initialize(pendoParams);
                console.log('pendo initialised', pendoParams);
            }
        }
    }, [shouldPendoInitialize]);
    useEffect(() => {
        if (!registered) {
            // console.log(
            //   'Device not Registered.Inititating devce registration call with public key',
            //   registered
            // );
            dispatch(isRegistered(false));
        }
    }, []);
    useEffect(() => {
        if (!contextData && registered) {
            const token = dataService.getDeviceToken()
                ? dataService.getDeviceToken()
                : dataService.getDeviceToken();
            console.log('Context info not available yet. Inititating context info call', contextData);
            // console.log('Context info token is ', token);
            dispatch(setToken(token));
        }
        else if (registered && currntviewToken !== dataService.getDeviceToken()) {
            // console.log('Token is not same as the one in local storage');
            dataService.setDeviceToken(dataService.getDeviceToken());
        }
    }, [registered, dataService.getDeviceToken()]);
    useEffect(() => {
        console.log('Event message recieved:', eventMessage);
        if (eventMessage.data && eventMessage.event) {
            const eventData = eventMessage.data;
            const eventType = eventMessage.event;
            const messageTime = eventData.timestamp;
            if (eventType === 'refresh') {
                // console.log('Refreshing the view');
                const apis = eventData.api;
                // console.log('APIs:', apis);
                if (apis.length > 0 && apis.includes('status')) {
                    const localEventMessageTime = dataService.getEventMessageTime();
                    if (localEventMessageTime === messageTime) {
                        // Ignore if message times are same
                        return;
                    }
                    // console.log('Local event message time:', localEventMessageTime);
                    // if (!skip) refetch();
                    if (localEventMessageTime && localEventMessageTime < messageTime) {
                        setSkip(false);
                        // console.log('Status API called');
                    }
                }
            }
            else if (eventType === 'requestConsoleLog') {
                const requestId = eventData === null || eventData === void 0 ? void 0 : eventData.requestId;
                sendLogsToServer(requestId);
            }
            // dataService.setEventMessageTime(messageTime);
        }
    }, [eventMessage]);
    useEffect(() => {
        // Reload the page when a `refresh` event arrives on the events stream.
        //
        // This intentionally does NOT wait for `statusData`. Previously the reload
        // was gated on `statusData` (from GET <origin>/v1/<token>/status), which is
        // a fragile prerequisite — depending on the host it can be slow, error, or
        // be unreachable, and when it never resolves the reload silently never
        // fired (this is why it "didn't work" once deployed). The refresh event is
        // meant to trigger a reload on its own, and the reload itself re-fetches
        // everything fresh, so gating on `statusData` isn't needed. The guards below
        // keep this safe (no loops, no stale/duplicate reloads).
        if (eventMessage.data && eventMessage.event === 'refresh') {
            const messageTime = eventMessage.data.timestamp;
            const localEventMessageTime = dataService.getEventMessageTime();
            // Dedup: skip events we've already processed. The retained refresh
            // message is re-delivered on every (re)subscribe (e.g. right after this
            // reload reconnects), so without this the page would reload in a loop.
            if (localEventMessageTime &&
                messageTime &&
                Number(localEventMessageTime) >= messageTime) {
                return;
            }
            // Freshness: only act on reasonably fresh events (< 120s old), measured
            // against the incoming event's own timestamp. This ignores stale retained
            // events without blocking live ones.
            if (!messageTime || Date.now() / 1000 - messageTime >= 120) {
                return;
            }
            // Stop the (now non-essential) status query from re-triggering renders.
            setSkip(true);
            const reloadTimer = window.setTimeout(() => {
                // console.log('Refreshing the page after delay');
                let redirectUrl = window.location.origin +
                    '?token=' +
                    dataService.getDeviceToken() +
                    '&cacheBust=' +
                    Date.now();
                // preserve debug flags in redirect
                const origParams = new URLSearchParams(window.location.search);
                if (origParams.get('enableDebugLogs') === 'true') {
                    redirectUrl += '&enableDebugLogs=true';
                }
                // Persist the processed event's timestamp so the retained message
                // that replays after reload is deduped by the guard above.
                dataService.setEventMessageTime(messageTime);
                window.location.replace(redirectUrl);
            }, (eventMessage.data.delay + 5) * 1000);
            // If a newer event arrives before this fires, cancel the pending reload
            // and let the newer one schedule its own.
            return () => clearTimeout(reloadTimer);
        }
    }, [eventMessage]);
    // Handler for clearing cache and reloading
    const handleClearCache = () => {
        try {
            localStorage.clear();
            sessionStorage.clear();
            dataService.clearAllClientCache && dataService.clearAllClientCache();
        }
        catch (e) {
            // ignore
        }
        dispatch(clearError());
        // Determine redirect based on whether in configure (tenantMask) or workspaces mode
        loadPage(dataService);
    };
    // --- DEBUG MODE HOOKUP ---
    if (typeof window !== 'undefined') {
        // Expose NATS client and debug toggler
        window.__NATS_CLIENT = NatsClient;
        window.enableNatsDebug = function () {
            var _a;
            window.__NATS_DEBUG_MODE = true;
            if (!window.__NATS_DEBUG_MESSAGES)
                window.__NATS_DEBUG_MESSAGES = [];
            // Patch processMessage to collect messages
            if (!window.__NATS_DEBUG_PATCHED) {
                const orig = (_a = NatsClient.processMessage) === null || _a === void 0 ? void 0 : _a.bind(NatsClient);
                NatsClient.processMessage = function (subject, msg, source) {
                    try {
                        const decoded = NatsClient.codec.decode(msg.data);
                        if (window.__NATS_DEBUG_MESSAGES) {
                            window.__NATS_DEBUG_MESSAGES.push({
                                subject,
                                message: decoded,
                                channel: source,
                                time: Date.now(),
                            });
                            if (window.__NATS_DEBUG_MESSAGES.length > 200) {
                                window.__NATS_DEBUG_MESSAGES.shift();
                            }
                        }
                    }
                    catch (e) {
                        /* ignore */
                    }
                    if (orig)
                        orig(subject, msg, source);
                };
                window.__NATS_DEBUG_PATCHED = true;
            }
            // Show popup
            if (!document.getElementById('nats-debug-root')) {
                const root = document.createElement('div');
                root.id = 'nats-debug-root';
                document.body.appendChild(root);
                // Render React popup
                import('./common/NatsDebugPopup').then((mod) => {
                    const popup = React.createElement(mod.NatsDebugPopup, {
                        natsClient: NatsClient,
                    });
                    window.__NATS_DEBUG_POPUP = popup;
                    // Use dynamic import for ReactDOM
                    import('react-dom/client').then((ReactDOM) => {
                        const rootInstance = ReactDOM.createRoot(root);
                        rootInstance.render(popup);
                    });
                });
            }
            console.log('NATS debug mode enabled. Use window.__NATS_CLIENT and window.__NATS_DEBUG_MESSAGES.');
        };
        window.disableNatsDebug = function () {
            window.__NATS_DEBUG_MODE = false;
            const root = document.getElementById('nats-debug-root');
            if (root)
                root.remove();
            window.__NATS_DEBUG_POPUP = null;
            console.log('NATS debug mode disabled.');
        };
    }
    if (typeof window !== 'undefined') {
        // Check URL parameters for debug toggles
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('enableDebugLogs') === 'true') {
            window.enableDebugLogs = true;
        }
        if (urlParams.get('enableNatsDebug') === 'true' &&
            typeof window.enableNatsDebug === 'function') {
            window.enableNatsDebug();
        }
    }
    // Building-level `showOnKioskAndWebApp === false`: show the restricted-access
    // error for kiosk/web views, excluding Navigator.
    if (isBuildingRestricted) {
        return _jsx(Error, { message: "common.error.building-access-restricted" });
    }
    // Floor/default-floor signage with no accessible floor: show the existing E403.
    if (isFloorRestricted) {
        return _jsx(Error, { message: "common.error.floor-access-restricted" });
    }
    switch (viewType) {
        case 'building':
            return _jsx(BuildingView, {});
        case 'floor':
            return _jsx(FloorView, { id: selectedLocation });
        case 'navigator':
            return _jsx(NavigatorView, {});
        case 'error':
            return (_jsx(Error, { message: error === null || error === void 0 ? void 0 : error.message, showClearCache: !!(error && error.showClearCache), onClearCache: error && error.showClearCache ? handleClearCache : undefined, errorCode: error === null || error === void 0 ? void 0 : error.errorCode }));
        default:
            return _jsx(Loader, {});
    }
}
